import { styled } from '@mui/material/styles'
import { IconButton } from '@mui/material'

export const SendFieldIconButton = styled(IconButton)`
  width: 40px;
  height: 40px;
  align-self: center;
  color: ${({ theme }) => theme.palette.neutral500};
`
